<template>
  <div class="image_bg">
    <div class="form">
      <div class="brand_box_b">
        <div class="brand_name">有朋相册空间</div>
        <div class="brand_dscp">您的专属家庭相册、朋友相册、团队相册<br>一个有温度的共享相册</div>
      </div>
      <div class="login_box_b">
        <div class="field_box">
          <!-- <div class="btn_small" @click="getSmsCode" v-if="smsCodeTime === 0">获取验证码</div>
          <div class="btn_small" v-if="smsCodeTime > 0">{{smsCodeTime}}s</div> -->
          <input class="field" placeholder="请输入动态密码" type="text" v-model.trim="smsCode" maxlength="11"/>
        </div>
        <div class="btn_large" @click="login">确定</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, Indicator } from 'mint-ui'
export default {
  name: 'Signup',
  data: function () {
    return {
      mobilePhone: '',
      smsCode: '',
      smsCodeTime: 0
    }
  },
  created() {
      this.mobilePhone = this.$route.query.mobilePhone;
      this.getSmsCode();
  },
  methods: {
    async getSmsCode () {
      try {
        if (!this.mobilePhone) {
          return Toast({
            message: '请填写手机号码'
          })
        }
        this.smsCodeTime = 60
        const smsCodeTimer = setInterval(() => {
          this.smsCodeTime -= 1
          if (this.smsCodeTime <= 0) {
            clearInterval(smsCodeTimer)
          }
        }, 1000)
        await this.$faApi.getSmsCode({
          mobilePhone: this.mobilePhone
        })
      } catch (err) {
        this.$faLogger.error('Signup.vue:getSmsCode', err)
      }
    },

    async login () {
      try {
        if (!this.smsCode) {
          return Toast({
            message: '请填写验证码'
          })
        }
        
        Indicator.open()

        const loginRes = await this.$faApi.login_sms({
          mobilePhone: this.mobilePhone,
          smsCode: this.smsCode
        })

        if (loginRes.code === 'INVALID_SMS_CODE') {
          Indicator.close()
          return Toast({ message: '验证码错误' })
        }
        
        // 登录完成之后保存accessToken
        localStorage.setItem(this.$faStorage.keys.accessToken, loginRes.accessToken)

        // 加入群
        const inviteCode = localStorage.getItem(this.$faStorage.keys.inviteCode)
        const groupId = localStorage.getItem(this.$faStorage.keys.inviteGroupId)
        if (inviteCode && groupId) {
          const joinGroupRes = await this.$faApi.joinGroupWithInviteCode(inviteCode, groupId)
          if (joinGroupRes.code === 'INVALID_INVITE_CODE') {
            Indicator.close()
            return Toast({ message: '无效邀请码' })
          }
          localStorage.removeItem(this.$faStorage.keys.inviteCode)
          localStorage.removeItem(this.$faStorage.keys.inviteGroupId)
          Indicator.close()
          return this.$router.push({ path: `/group/${groupId}` })
        }

        const loginRedirectUrl = localStorage.getItem(this.$faStorage.keys.loginRedirectUrl)

        Indicator.close()
        if (loginRedirectUrl) {
          localStorage.removeItem(this.$faStorage.keys.loginRedirectUrl)
          return this.$router.push({ path: loginRedirectUrl })
        } else {
          return this.$router.push({ path: `/user/${loginRes.userId}/joined_groups` })
        }
      } catch (err) {
        Indicator.close()
        this.$faLogger.error('Login.vue:getSmsCode', err)
      }
    },
  }
}
</script>

<style scoped lang="scss">
  .main {
    margin: 0 auto;
    padding: 16px;
    max-width: 320px;
  }
  .brand_box {
    margin-bottom: 48px;
    position: relative;
    text-align: center;
    .title {
      margin: 0;
      font-size: 30px;
      font-weight: bold;
      span {
        font-weight: bold;
      }
    }
    .subtitle {
      margin: 0;
      font-size: 18px;
      font-weight: 300;
      color: black;
    }
    .logo {
      position: relative;
      margin: 16px auto;
      width: 160px;
      height: 160px;
    }
    .logo_image {
      position: relative;
      width: 100%;
      height: 100%;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      background-image: url('../assets/logo_960.png');
    }
  }
  .field_box {
    position: relative;
  }
  .field {
    margin: 8px 0 0 0;
    width: 100%;
    height: 40px;
    border-width: 0 0 1px 0;
    border-radius: 0;
    border-bottom: 1px solid #e0e0e0;
    background-color: #ffff;
    text-align: left;
    font-size: 16px;
    font-weight: 300;
  }
  .btn_small {
    position: absolute;
    top: 12px;
    right: 0;
    margin: 0;
    padding: 0 4px;
    width: 80px;
    height: 32px;
    line-height: 32px;
    font-size: 12px;
    font-weight: bold;
    border-radius: 4px;
    text-align: center;
    color: white;
    background-color: red;
    z-index: 999;
    cursor: pointer;
  }
  .btn_large {
    margin: 24px auto 16px auto;
    height: 40px;
    line-height: 40px;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 900;
    text-align: center;
    color: white;
    background-color: red;
    cursor: pointer;
  }
  .btn_box {
    position: relative;
    width: auto;
    height: 32px;
  }
  .btn_center {
    position: relative;
    width: auto;
    padding: 0 8px;
    height: 32px;
    line-height: 32px;
    font-size: 12px;
    font-weight: normal;
    text-align: center;
    color: darkgray;
    span {
      font-weight: bold;
      color: red;
      cursor: pointer;
    }
  }
</style>
